import { distinctUntilChanged, map } from 'rxjs/operators';
import { Timestamp, OrderByDirection } from 'firebase/firestore';
import { OperatorFunction } from 'rxjs';
import { orderByTimestamp } from './array.utils';
import { FirestoreDocument } from '../../libs/shared/models/firestore-document';
import { DocumentReference, refEqual } from '@angular/fire/firestore';

export function mapOrderByTimestamp<T>(
  property: keyof {
    [K in keyof T as T[K] extends Timestamp ? K : never]: T[K];
  },
  direction: OrderByDirection
): OperatorFunction<FirestoreDocument<T>[], FirestoreDocument<T>[]> {
  return map((array: FirestoreDocument<T>[]) => orderByTimestamp(array, property, direction));
}

export function distinctUntilRefChanged<T>(): OperatorFunction<
  FirestoreDocument<T> | null,
  FirestoreDocument<T> | null
> {
  return distinctUntilChanged((a, b) => (a && b && refEqual(a.ref, b.ref)) || a === b);
}

export function distinctUntilPropertyChanged<T, K extends keyof T>(
  property: K
): OperatorFunction<FirestoreDocument<T>, FirestoreDocument<T>> {
  return distinctUntilChanged((a, b) => !hasPropertyChanged(a, b, property));
}

function hasPropertyChanged<T, K extends keyof T>(
  oldObject: FirestoreDocument<T>,
  newObject: FirestoreDocument<T>,
  property: K
) {
  const oldValue = oldObject.data[property];
  const newValue = newObject.data[property];
  if (oldValue instanceof DocumentReference || newValue instanceof DocumentReference) {
    return !(
      oldValue instanceof DocumentReference &&
      newValue instanceof DocumentReference &&
      refEqual(oldValue, newValue)
    );
  }
  return oldValue !== newValue;
}
